import styled from 'styled-components'

export const ListScrollerContent = styled.div<{ border?: boolean }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow-x: hidden;
    flex: 1;
    background-color: var(--color-white);
    border-radius: 12px;
    border: ${({ border }) => (border ? '1px solid var(--color-gray-300)' : 'none')};
`

export const TableNoDataContent = styled.div<{ width?: number }>`
    width: ${({ width }) => (width ? `${width - 2}px` : '100%')};
    padding: 16px 0;
    position: sticky;
    left: 0;
    top: 0;
`
